import { graphql } from 'react-relay';

export const ValidatePromotionalCodeQuery = graphql`
  query ValidatePromotionalCodeQuery($code: String!) {
    validatePromotionalCode(code: $code) {
      valid
      plans {
        slug
        name
        valueCents
        comingSoon
        effectiveValueCents
        discountLabel
        discountDuration
        durationMonths
      }
    }
  }
`;
